// extracted by mini-css-extract-plugin
export default {"crumb":"style-module--crumb--nyLjN"};